import { ApiError } from './client';
import { PermissionRefusalCodeSchema } from './schemas/permissionRefusal';

// A Rechazo por permiso: the server knew the caller and refused the permission the route declares.
// Only the recognised codes count. Any other 403 — `permission_denied` for a non-Citibox identity,
// or a body with no code from infrastructure, which ApiError reports as HTTP_403 — stays an
// ordinary error, so an infrastructure block is never presented as a missing permission. It reads
// the code alone, so a `detail` or `message` that drifts from the delivered shape cannot turn a
// refusal into a generic error.
export function isPermissionRefused(error: unknown): error is ApiError {
  if (!(error instanceof ApiError) || error.status !== 403) return false;
  const parsed = PermissionRefusalCodeSchema.safeParse(error.body);
  return parsed.success && parsed.data.code === error.code;
}
